module.exports = __webpack_public_path__ + "img/inBan_smal_img04.69fd1b66.png";